"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const components_1 = require("components");
function ToastDismissButton({ closeToast, }) {
    return ((0, jsx_runtime_1.jsx)(components_1.ButtonLink, { onClick: closeToast, className: "link-secondary", children: "Dismiss" }));
}
exports.default = ToastDismissButton;
